import { create } from 'zustand';

/*
 * Opening the documents import (docs/ImportDialog.tsx) from anywhere: the organization menu, a
 * space's documents, a page's menu ("import here"). The dialog itself loads only when opened.
 */

export interface ImportTarget {
  teamId?: string;
  spaceId?: string;
  /** Under this page; the space's top level without one. */
  parentId?: string;
  parentTitle?: string;
}

export const useDocsImport = create<{ target: ImportTarget | null }>(() => ({ target: null }));

export const openDocsImport = (target: ImportTarget = {}) => useDocsImport.setState({ target });
export const closeDocsImport = () => useDocsImport.setState({ target: null });
